import script from "./Treatment.vue?vue&type=script&setup=true&lang=js"
export * from "./Treatment.vue?vue&type=script&setup=true&lang=js"

import "./Treatment.vue?vue&type=style&index=0&id=320807c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-320807c6"]])

export default __exports__